//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    show: Boolean,
    disclosure: String,
    metadata: {
      /* example: { first_name: 'Test', last_name: 'User' } */
      type: Object,
      default: () => {
        return {};
      }
    },
    viewOnly: Boolean
  },

  data() {
    return {
      html: ''
    };
  },

  watch: {
    show: {
      handler(newVal) {
        if (!newVal) return;
        this.handleDisclosure();
      }

    }
  },

  mounted() {
    if (this.show) this.handleDisclosure();
  },

  methods: {
    handleDisclosure() {
      if (!this.disclosure) {
        this.html = '';
        return;
      }

      let text = require(`../../content/html/${this.disclosure}.html`);

      for (const key in this.metadata) {
        text = text.replaceAll('{{' + key + '}}', this.metadata[key] || '');
      }

      this.html = text;
    }

  }
};